import Col from 'react-bootstrap/Col';
import ListGroup from 'react-bootstrap/ListGroup';
import Row from 'react-bootstrap/Row';
import Tab from 'react-bootstrap/Tab';
import { Link } from 'react-router-dom';

function Main({ activeIndex }) {



    return (
        <Tab.Container id="list-group-tabs-example" defaultActiveKey="#link1">
            <Row>
                <Col sm={12}>
                    <ListGroup>

                        <ListGroup.Item as={Link} action to="/resourcesacademics" className={`p-3 ${activeIndex==0 ? " active" : ""}`}>
                            <i className="fas fa-chevron-circle-right me-3"></i>
                            Infrastructure
                        </ListGroup.Item>

                        <ListGroup.Item as={Link} action to="/computing-facilities" className={`p-3 ${activeIndex==1 ? " active" : ""}`}>
                            <i className="fas fa-chevron-circle-right me-3"></i>
                            Computer Center
                        </ListGroup.Item>

                        <ListGroup.Item as={Link} action to="https://library.iittp.ac.in/" className={`p-3 ${activeIndex == 2 ? " active" : ""}`}>
                            <i className="fas fa-chevron-circle-right me-3"></i>
                            Central Library
                        </ListGroup.Item>

                        <ListGroup.Item as={Link} action to="/creche" className={`p-3 ${activeIndex == 3 ? " active" : ""}`}>
                            <i className="fas fa-chevron-circle-right me-3"></i>
                            Creche
                        </ListGroup.Item>

                    </ListGroup>
                </Col>
                {/* <Col sm={8}>
          <Tab.Content>
            <Tab.Pane eventKey="#link1">Tab pane content 1</Tab.Pane>
            <Tab.Pane eventKey="#link2">Tab pane content 2</Tab.Pane>
          </Tab.Content>
        </Col> */}
            </Row>
        </Tab.Container>
    );
}

export default Main;